<p-carousel [value]="blogData">
    <ng-template let-feature pTemplate="item">
        <div class="mb-2">
            <div class="font-semibold text-xs" >{{feature.pubDate | date: 'dd MMM YYYY' }}</div>
            <div class="mx-auto font-medium text-5xl my-4">{{feature.title  }}</div>
            <div class="m-0 line-height-3 text-xl" [innerHTML]="feature.description"></div>
        </div>
    </ng-template>
</p-carousel>